import Image from "next/image";
import Link from "next/link";
import { getType } from "../util/functions";

const NewsCard = ({ news }: { news: any }) => {
	const kindObj = getType(news.content?._class);
	return (
		<div
			className="p-2 shadow-lg w-[337px] news-card"
			style={{
				backgroundImage:
					news.content?._class === "series" || news.content?._class === "movie"
						? `url('/news-card-pink.png')`
						: news.content?._class === "game"
							? `url('/news-card-green.png')`
							: `url('/news-card-blue.png')`,
			}}
		>
			<Link
				href={`/news/${kindObj?.kind}/${news.id}`}
				className={"hover:opacity-70"}
			>
				<Image
					src={process.env.NEXT_PUBLIC_FILE_URL + news.posterImage?.code}
					alt={news.title}
					width={306}
					height={118}
					layout="contain"
					className={
						"m-auto max-w-[306px] max-h-[118px] min-h-[118px] min-w-[118px]"
					}
				/>
				<div className="relative h-[88px] w-[330px] z-10 px-4 py-2">
					<div className="flex justify-between items-start">
						<span className="text-white/60 font-normal text-[14px] py-1">
							{kindObj?.name}
						</span>
					</div>
					<div className="text-start font-semiBold text-[16px] text-white text-sm mt-1">
						{news.title}
					</div>
				</div>
			</Link>
		</div>
	);
};

export default NewsCard;
